export class FabricModel {
    constructor(
       public left?: any,
       public top?: any,
       public width?: any,
       public height?: any,
    ) {}
}
export class ImageCanvasModel {
   
    constructor(
        public canvasOriginalWidth?: number,
        public canvasOriginalHeight?: number,
        public canvasWidth?: number,
        public canvasHeight?: number,
        public imgWidth?: number,
        public imgHeight?: number,
        public canvasScaleX?: number,
        public canvasScaleY?: number,
     ) {
     }
}
